import { CldImage } from "next-cloudinary";
import styles from "./CharityLogoBars.module.scss";
import Link from "next/link";

export default function CharityLogoBars({}) {
  const charities = [
    {
      name: "1% for the Planet",
      logoUrl:
        "https://res.cloudinary.com/dail4fbms/image/upload/v1697102874/one_percent_for_the_planet_fcfd832d57.png",
      text: "1% of your purchase will go to a grassroot charity.",
      url: "/about/one-percent-for-the-planet",
    },
    {
      name: "One Tree Planted",
      logoUrl:
        "https://res.cloudinary.com/dail4fbms/image/upload/v1629876553/One_Tree_Planted_Key_Logo_Long_White_42145cc979.png",
      text: "25 trees will be planted on your behalf with this purchase.",
      url: "/about/one-tree-planted",
    },
    // {
    //   name: "Pledge 1%",
    //   logoText: "1%",
    //   text: "1% of profits from this experience go to environmental charities",
    // },
  ];

  const charityBars = charities.map((charity) => {
    return <CharityLogoBar charity={charity} key={charity.name} />;
  });

  return <div>{charityBars}</div>;
}

function CharityLogoBar({ charity }) {
  const { logoUrl, logoText, text, name, url } = charity;

  return (
    <div className={`${styles.charityLogoBar}`}>
      {logoUrl && (
        <span className={`${styles.iconWrapper}`}>
          <CldImage
            src={logoUrl}
            alt={`${name} logo`}
            fill
            sizes={`(min-width: 320px) 368px`}
            className={`${styles.icon}`}
          />
        </span>
      )}
      {logoText && (
        <span className={`${styles.icon} ${styles.textIcon}`}>{logoText}</span>
      )}

      <p className={`${styles.text}`}>{text}</p>
      <Link href={url} className={`${styles.charityLink}`}>
        Learn more
      </Link>
    </div>
  );
}
